var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component",class:_vm.layoutClass},[(_vm.layout === 'Loading')?_vm._t("default"):_c('router-view',{key:_vm.routerViewKey})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }